import React from 'react';
import './ColumnRight.css';

const ColumnRight = () => (
  <div className="columnRight">
    <div className="groove" />
    <div className="groove" />
    <div className="groove" />
    <div className="groove" />
    <div className="groove" />
    <div className="head" />
    <div className="head2" />
  </div>
);

export default ColumnRight;
